<app-titolo-subtitolo
  [subTitolo]="tipoIro + ' - ' + titolo"
  [titolo]="'Risultato validazioni'"
></app-titolo-subtitolo>

<div mat-dialog-content class="dialog-center-cont cont-bordato">
  @for (comp of data.elemento.compilazioni; track $index) {
    <div class="validazione">
      <div>{{ comp.nomeValidatore }}</div>
      <div>
        Esito :
        @if (comp.validato) {
          <span class="valido">VALIDO</span>
        } @else {
          <span class="non-valido">NON VALIDO</span>
        }
      </div>
      @if (!comp.validato) {
        <div>Motivazione: {{ comp.rispostaData }}</div>
      }
    </div>
  }
</div>

<div mat-dialog-actions class="dialog-footer-cont">
  <button mat-dialog-close mat-flat-button color="primary" class="primary-button">Ok</button>
</div>
